import { observer } from "mobx-react";
import { useUI } from "~/hooks/useUI";
import Icon from "~/components/Icon";
import { GlobalLoadingOverlay, Spinner } from "./GlobalSpinner.styled";

export const SpinnerIcon = () => {
  return (
    <Spinner>
      <Icon variant="spinner" width="40" height="40" />
    </Spinner>
  );
};

const GlobalSpinner = observer(() => {
  const ui = useUI();

  if (!ui.isLoading) return null;

  return (
    <GlobalLoadingOverlay>
      <SpinnerIcon />
    </GlobalLoadingOverlay>
  );
});

export default GlobalSpinner;
